import { createElement, createContext, useContext, ReactNode } from 'react';
import { SplitterDataProvider } from '../types';
import { getSplitterDataProvider } from '../__internal__/SplitterDataProvider';

const PersistedSplitterContext = createContext<SplitterDataProvider | undefined>(undefined);
PersistedSplitterContext.displayName = 'PersistedSplitter';

export const PersistedSplitterProvider = (props: {
  children?: ReactNode;
  value?: SplitterDataProvider;
}) => {
  return (
    <PersistedSplitterContext.Provider value={props.value ?? getSplitterDataProvider()}>
      {props.children}
    </PersistedSplitterContext.Provider>
  );
};

export const usePersistedSplitter = () => {
  return useContext(PersistedSplitterContext);
};
